module.exports = __webpack_public_path__ + "static/media/BG-contract-Epargne.04c6cbaa.svg";